<template>
  <div class="lot col-lg-4 col-xs-12 flex-column mb-5">
    <a
        style="top:0; right:0;"
        v-if="admin_status === '4dm1n'"
        target="_blank"
        class="absolute rounded-0 float-right h8 px-2"
        :href="'/nova/resources/lots/' + lot.id + '/edit'"
    >
      <svg
          width="15"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 259.465 259.465"
          style="enable-background:new 0 0 259.465 259.465;"
          xml:space="preserve"
      >
        <g>
          <path
              style="fill:#888;"
              d="M190.239,0l-38.46,38.46L43.276,146.969L0.003,259.465l112.496-43.268l116.195-116.195l0,0
            l30.769-30.769L190.239,0z M18.947,240.521l9.692-25.21l15.512,15.512L18.947,240.521z M106.44,206.869l-51.182,19.684
            l-22.349-22.349l17.09-44.448l24.851,24.851l7.691-7.691l-26.923-26.923l73.079-73.074l19.227,19.233l7.691-7.691l-19.227-19.233
            l7.691-7.691l19.233,19.233l7.691-7.691l-19.227-19.233l7.691-7.691l34.614,34.614l-96.146,96.152l7.691,7.691l96.152-96.152
            l11.536,11.536L106.44,206.869z M221.003,92.306l-53.841-53.841l23.078-23.078l53.841,53.841L221.003,92.306z"
          />
        </g>
      </svg>
    </a>
    <div class="mt-0 lot-image text-center pb-3">
      <a :href="url" v-on:click="goToLot">
        <div
            class="min-height-400 d-flex justify-content-center center-vertically"
            v-lazy-container="{
            selector: 'img',
         error: 'https://artmark.ro/assets/img/eror404-02.png',
            loading: 'https://artmark.ro/assets/img/eror404-02.png'
          }"
        >
          <div v-if="auction.order == 411 && lot.number == 157">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/157.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 411 && lot.number == 158">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/158.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 411 && lot.number == 159">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/159.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 411 && lot.number == 160">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/160.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 438 && lot.number == 61">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/438-61.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 438 && lot.number == 62">
            <video style="max-height: 400px" controls loop>
              <source src="https://www.artmark.ro/assets/img/lots-video/438-62.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 442 && lot.number == 2">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/442-2.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 442 && lot.number == 3">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/442-3.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 442 && lot.number == 4">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/442-4.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 442 && lot.number == 6">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/442-6.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 451 && lot.number == 139">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/451-139.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 451 && lot.number == 143">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/451-143.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else-if="auction.order == 462 && lot.number == 116">
            <video style="max-height: 400px" controls muted loop onmouseover="this.play()" onmouseout="this.pause();">
              <source src="https://www.artmark.ro/assets/img/lots-video/462-116.mp4" type="video/mp4">
            </video>
          </div>
          <div v-else>
            <img class="img-fluid" :data-src="img" :alt="lot.title"/>
          </div>

        </div>
      </a>
    </div>
    <div class="align-self-baseline w-100 text-left">
      <a :href="url" v-bind:click="goToLot">
        <!--        <div v-if="auction.offer_status === 2 ||(auction.offer_status === 3 && lot.auction_status == 2) || auction.offer_status === 1">-->
        <div class="row">
          <div v-bind:class="(lot.buttons.length == 0)?'col-12':'col-7'">
            <span class="font-weight-bold" v-html="makeLotShortName()"></span>
          </div>

          <div v-bind:class="(lot.buttons.length == 0)?'hidden':'col-5'">
            <div class="row justify-content-end">
              <div class="col-12" style="padding-right:0px;justify-content: right; display: flex;"
                   v-for="btnType in lot.buttons">
                <button type="button" name="button" class="btn btn-dark rounded-0 float-right h8"
                        :class="makeBtnLabel(btnType).class"
                        v-on:click="callMethodByString(makeBtnLabel(btnType).method, $event)">
                  {{ makeBtnLabel(btnType).label }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="lot.hasTreasure" class="col-12 d-flex justify-content-center align-items-center">
          <form action="/treasureHuntFound" method="get">
            <input type="hidden" name="lot_id" :value="lot.id"/>
            <button type="submit" class="p-0 border-0">
              <img width="128px" src="/assets/img/promo1.jpg"/>
            </button>
          </form>
        </div>
        <div class="row d-flex flex">
          <div class="col-7" style="padding-right: 0px !important;">
        <span v-html="makeArtistLink(lot.artists)">
<!--          <span id="lotArtist" v-if="artist.firstname && artist.lastname">{{ artist.firstname }} {{-->
          <!--              artist.lastname-->
          <!--            }}<span v-if="index != lot.artists.length - 1">, </span></span>-->
          <!--          <span id="lotArtist" v-else-if="artist.firstname">{{ artist.firstname }}<span-->
          <!--              v-if="index != lot.artists.length - 1">, </span></span>-->
          <!--          <span id="lotArtist" v-else-if="artist.lastname">{{ artist.lastname }}<span-->
          <!--              v-if="index != lot.artists.length - 1">, </span></span>-->
          <!--          <span id="lotArtist" v-else>{{ artist.name }}<span v-if="index != lot.artists.length - 1">, </span>-->
          </span>

            <div v-if="!lot.artists && lot.old_artist">
              {{ lot.old_artist }}
            </div>
            <span v-for="(price, price_name) in lot.prices" :key="price_name">
        <div
            v-if="!['Donații curente', 'Donatori', 'Donator', 'Current donations', 'Donors', 'Donor'].includes(price_name)"
            class="h7 text-left text-muted">
            <span v-html="price_name"/><span v-html="price"/>
        </div>
    </span>
          </div>
          <div class="col-5 pr-0" style="justify-content: right; display: flex;">
            <span class="span-lot-badges" v-if="lot.is_charitable">
            <img src="/assets/img/Inima_caritabile.png" width="25px" height="25px"/>
            </span>
            <span class="span-lot-badges" v-for="(badge, badge_name) in lot.badges" :key="badge_name">
              <img :src="badge" width="25px" height="25px"/>
            </span>
            <span class="span-lot-badges">
            <button v-if="isFavorite" id="btn-unfavorite" @click="removeFromFavorites"
                    data-toggle="modal"
                    data-target="#favoritesModal"
                    type="button" class="btn btn-fav" v-bind:title="titleUnfav"
                    data-placement="left" style="margin-right: 25px;">
              <svg enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063zm0 0"/>
              </svg>
            </button>
              <button v-if="!isFavorite" id="btn-favorite" @click="addToFavorites" type="button"
                      data-placement="left"
                      class="btn btn-fav" v-bind:title="titleFav">
                <svg enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"/>
                </svg>
              </button>
            </span>
            <span class="span-lot-badges">
              <button
                  @click="openShareModal"
                  type="button"
                  class="btn showShareModal"
                  data-toggle="modal"
                  title="Share"
                  data-placement="left"
                  data-target="#shareModal"
              >
                <svg id="Capa_1" enable-background="new 0 0 512 512" height="20"
                     viewBox="0 0 512 512"
                     width="20" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <path
                        d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"/>
                  </g>
                </svg>
              </button>
            </span>
          </div>
        </div>
      </a>
      <div class="row d-flex flex">
          <div v-if="this.$route.meta.isSearch == true || this.$route.meta.isArtist == true" class="col-12 text-left h7 mt-0 pt-2">
            <a :href="urlAuction">{{ auction.name }}</a>
          </div>
        </div>
    </div>
    <div class="iziToast-wrapper-modal" :id="'showMessage_' + lot.id"></div>
  </div>
</template>


<script>

export default {
  data: function () {
    return {
      biddingSteps: {},
      user_has_bids_on_lot: false,
      highest_bidder: false,
      titleFav: window.AG.locale == 'ro' ? 'Adaugă la favorite' : 'Add to favorites',
      titleUnfav: window.AG.locale == 'ro' ? 'Elimină de la favorite' : 'Remove from favorites',
      isFavorite: this.lot.favorited,
      type: "",
    };
  },
  props: ["lot", "auction"],
  computed: {
    console: () => console,
    img: function () {
      return this.lot.auction_listing_image_url;
    },
    urlAuction: function () {
      var localized = "auction";
      if (window.AG.locale === "ro") {
        localized = "licitatie";
      } else if (window.AG.locale === "hr") {
        localized = 'aukcija';
      }

      return this.$router.resolve({
        name: "auction",
        params: {
          auction: this.auction.slug,
          localized: localized
        }
      }).href;
    },
    url: function () {
      var localized = "auction";
      if (window.AG.locale === "ro") {
        localized = "licitatie";
      } else if (window.AG.locale === "hr") {
        localized = 'aukcija';
      }

      return this.$router.resolve({
        name: "lot",
        params: {
          auction: this.auction.slug,
          lot: this.lot.slug,
          localized: localized
        }
      }).href;
    },
    admin_status: function () {
      return window.AG.astatus;
    },
  },
  loggedIn: function () {
    return window.AG.loggedIn;
  },
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    locale: function () {
      return window.AG.locale;
    },
    makeArtistLink: function (artists) {
      // <!--              v-if="index != lot.artists.length - 1">, </span></span>-->
      //   <!--          <span id="lotArtist" v-else>{{ artist.name }}<span v-if="index != lot.artists.length - 1">, </span>-->
      var result = '';
      var locale = this.locale();
      var artistTrans = this.__('artist');
      artists.forEach(function (artist, i) {
        var end = '';
        if (i < artists.length - 1 && artists.length > 1) {
          end = '<span>, </span>';
        }
        if (artist.has_page) {
          result = result + '<span id="lotArtist"><a href="/' + locale + '/' + artistTrans + '/' + artist.slug + '" style="text-decoration: underline">' + artist.name + end + '</a></span>';
        } else {
          result = result + '<span id="lotArtist">' + artist.name + end + '</span>';
        }
      })
      return result;
    },
    goToLot: function (event) {
      var localized = "auction";
      if (window.AG.locale === "ro") {
        localized = "licitatie";
      } else if (window.AG.locale === "hr") {
        localized = 'aukcija';
      }
      if (this.$route.meta.isSearch == true || this.$route.meta.isArtist == true) {
        location.replace('/' + localized + '/' + this.auction.slug + '/lot/' + this.lot.slug);
      } else {
        this.$router.push({
          name: "lot",
          params: {
            localized: localized,
            auction: this.auction.slug,
            lot: this.lot.slug
          }
        });
        event.preventDefault();
        return false;
      }
    },
    callMethodByString: function (methodString, event) {
      this[methodString](event);
    },
    makeBtnLabel: function (btnType) {
      let result = [];

      switch (btnType) {
        case 'buy-offer':
          result['label'] = this.lot.is_fapte_bune == 'FB' ? this.__('donate') : this.__('place-offer-call-to-action');
          result['method'] = 'goToOffer';
          result['class'] = 'btn-buy-offer';
          break;
        case 'buy-post':
          result['label'] = this.__("buy_now");
          result['method'] = 'goToOfferPost';
          result['class'] = 'btn-buy-post';
          break;
        case 'buy-shop':
          result['label'] = this.__("buy_shop");
          result['method'] = 'goToShop';
          result['class'] = 'btn-buy-shop';
          break;
      }
      return result;
    },
    goToOffer: function (event) {
      var localized = "auction";
      if (window.AG.locale === "ro") {
        localized = "licitatie";
      }
      if (this.$route.meta.isSearch == true) {
        location.replace('/' + localized + '/' + this.auction.slug + '/lot/' + this.lot.slug);
      } else {
        this.$router.push({
          name: "lot",
          params: {
            localized: localized,
            auction: this.auction.slug,
            lot: this.lot.slug,
            goToOffer: 1
          }
        });
        event.preventDefault();
        return false;
      }
    },
    goToOfferPost: function (event) {
      // var localized = "auction";
      // if (window.AG.locale === "ro") {
      //   localized = "licitatie";
      // }
      // this.$router.push({
      //   name: "lot",
      //   params: {
      //     localized: localized,
      //     auction: this.auction.slug,
      //     lot: this.lot.slug,
      //   }
      // });
      // event.preventDefault();
      // return false;
      location.replace('/' + localized + '/' + this.auction.slug + '/lot/' + this.lot.slug);
    },
    goToShop: function (event) {
      window.open(this.lot.shop_url, '_blank');
    },
    makeLotShortName: function () {
      if (this.lot.whole_title && this.lot.whole_title.length >= 127) {
        var trimmedString = this.lot.whole_title.substring(0, 127);
        trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + '...';


        return trimmedString;

      } else {
        return this.lot.whole_title;
      }
    },
    makeEstimateMin: function () {
      return this.lot.estimate_min;
    },
    makeLotTitle: function (heritage, archive_preemption, is_price_cumulative) {
      let arrArguments = Array.from(arguments);
      let newArguments = [];
      arrArguments.map(function (value, key) {
        if (value != null || value != 0) {
          if (key == 1 && value == 1) {
            newArguments.push('A');
          } else if (key == 0 && value == 1) {
            newArguments.push('C');
          } else {
            if (value) {
              newArguments.push(value);
            }
          }
        }
      });
      if (newArguments.length > 0) {
        return this.lot.number + '<sup>' + newArguments.join(", ") + '</sup>. ' + this.makeLotShortName();
      } else {
        return this.lot.number + '. ' + this.makeLotShortName();
      }
    },
    addToFavorites: function (event) {
      document.activeElement.blur();
      if (window.AG.loggedIn != undefined) {
        event.stopPropagation();
        this.type = 'lot';

        axios({
          method: "post",
          url: "/api/add-favorites",
          data: {"favorites": [{"type": this.type, "id": this.lot.id}]},
          config: {
            headers: {
              "Content-Type": "application/json"
            }
          }
        }).then((response) => {
          this.isFavorite = true;
          var msg = window.AG.locale == 'ro' ? 'Opera a fost adăugată la Favorite!' : 'Artwork added to Favorites!';
          window.showToast(
              msg,
              "success",
              null,
              "#showMessage_" + this.lot.id
          );
          // $('#showMessage' + this.lot.id).text(msg);
          // $('#showMessage' + this.lot.id).delay(2000).fadeOut('slow', function () {
          //     $('#showMessage' + this.lot.id).show();
          //     $('#showMessage' + this.lot.id).text('');
          // });
        }).catch(function (error) {
          if (error.response.status === 401) {
            window.showToast(
                error.response.data.message,
                "error",
                null,
                "#showMessage_" + this.lot.id
            );
          } else {
            location.reload();
          }
        });
      } else {
        let localFavorites = localStorage.getItem('localFavorites');

        localFavorites = localFavorites ? localFavorites.split(',') : [];
        localFavorites.push(JSON.stringify({
          type: 'lot',
          fav_id: this.lot.id,
          whereFrom: location.href
        }));

        localStorage.setItem('localFavorites', localFavorites);
        localStorage.setItem('scrollPos', $(window).scrollTop());
        window.location.replace('/login');
      }
      event.preventDefault();
    },
    removeFromFavorites: function (event) {
      document.activeElement.blur();
      event.stopPropagation();
      this.type = 'lot';
      axios({
        method: "post",
        url: "/api/remove-favorites",
        data: {"favorites": [{"type": this.type, "id": this.lot.id}]},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then((response) => { //succes
        var msg = window.AG.locale == 'ro' ? 'Opera a fost eliminată de la Favorite!' : 'Artwork removed from Favorites!';
        this.isFavorite = false;
        window.showToast(
            msg,
            "warning",
            null,
            "#showMessage_" + this.lot.id
        );
      }).catch(function (error) {
        if (error.response.status === 401) {
          window.showToast(
              error.response.data.message,
              "error",
              null,
              "#showMessage_" + this.lot.id
          );
        } else {
          location.reload();
        }
      });
      event.preventDefault();
    },
    openShareModal: function (event) {
      var number = this.lot.number;
      var artist = null;
      if ($("#lotArtist").length > 0) {
        artist = ", " + $("#lotArtist").text();
      }
      var title = subject + ", " + this.lot.title.length > 130 ? this.lot.title.substring(0, 120) : this.lot.title;

      var txt = "Recomand A10 by Artmark - Lot ";
      if (window.AG.locale != 'ro') {
        txt = "Check out A10 by Artmark - Lot no. "
      }

      var subject = number + " " + title;
      if (artist) {
        subject = number + " " + artist + ", " + title;
      }
      var link = "https://www.artmark.ro" + this.url;
      var lastSlashPosition = link.lastIndexOf('/');
      var lotShareLink = link.substring(lastSlashPosition + 1);
      $("#shareModal").on("show.bs.modal", function (e) {
        $("#facebookShare").attr(
            "href",
            "https://www.facebook.com/sharer/sharer.php?u=https://www.artmark.ro/" + window.AG.locale + "/lot/" +
            lotShareLink +
            "&amp;display=popup"
        );
        $("#emailShare").attr(
            "href",
            "mailto: ?subject=" + txt + subject + "&body=" + txt + subject + "%0D%0A" + link
        )
        ;
      });
      event.preventDefault();
    },
    getBiddingSteps: function () {
      axios({
        method: "get",
        url: "/api/lot-bidding-steps",
        params: {id: this.lot.id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.biddingSteps = response.data;
      }).catch(error => {
      });
    },
    getHighestBidder: function () {
      axios({
        method: "get",
        url: "/api/lot-highest-bidder",
        params: {id: this.lot.id},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.highest_bidder = response.data.user_id
      }).catch();
    },
    userHasBids: function () {
      axios({
        method: "get",
        url: "/api/lot-user-has-bids",
        params: {id: this.lot.id, userId: this.loggedInId},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then(response => {
        this.user_has_bids_on_lot = response.data
      }).catch();
    },
    setupPusher: function () {
      if (this.loggedInId && this.approval_status == 2) {

        window.auctionPresenceChannel = Echo.join(`auction.${window.AG.auction.id}`)

        auctionPresenceChannel

            .here((members) => {

            })

            .joining((member) => {

            })

            .leaving((member) => {

            })

            .error((error) => {

            });

        Echo.encryptedPrivate(`bidders.auction.${window.AG.auction.id}`)
            .listen('.bid.win', (e) => {
              if (window.AG.auction.mode == 4 && e.lid == this.lot.id) {
                this.lot.live_price = e.p;
                this.lot.live_ask_price = e.k;
                $('#price_name').text(this.__("current-price"))
                $('#price_value').text('€ ' + e.p)
                this.getBiddingSteps();
                this.userHasBids();
                this.getHighestBidder();
              }
            })

      } else {

        window.auctionPresenceChannel = false

        Echo.channel(`guests.auction.${window.AG.auction.id}`)

            .listen('.bid.win', (e) => {
              if (window.AG.auction.mode == 4 && e.lid == this.lot.id) {
                this.lot.live_price = e.p;
                this.lot.live_ask_price = e.k;
                $('#price_name').text(this.__("current-price"))
                $('#price_value').text('€ ' + e.p)
                this.getBiddingSteps();
              }
            })
      }
    },
  },
  updated() {
    $('[data-toggle="modal"]').tooltip()
  },
  mounted() {
    if (localStorage.getItem('scrollPos') !== null && localStorage.getItem('scrollPos') !== '') {
      $(document).scrollTop(localStorage.getItem('scrollPos'));
      localStorage.removeItem('scrollPos');
    }

  }
};
</script>
